module.exports = __webpack_public_path__ + "static/media/utensil-spoon.712b2ec1.svg";